import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { PlatformService } from '@core/services/platform.service';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<boolean> {
  platformService = inject(PlatformService);

  async canDeactivate(): Promise<boolean> {
    if (this.platformService.hasUnsavedChanges) {
      try {
        await this.platformService.confirmUnsavedChangesNavigation();
        this.platformService.hasUnsavedChanges = false;

        return true;
      } catch {
        return false;
      }
    }

    return true;
  }
}
